import { z } from "zod";

export const renameFolderFormSchema = z.object({
	title: z.string().trim().min(1),
});

export type RenameFolderFormInput = z.input<typeof renameFolderFormSchema>;
export type RenameFolderFormOutput = z.output<typeof renameFolderFormSchema>;
